import { Vector3, Raycaster, Plane } from 'three'
export function pickingRay(vector, camera) {
  // set two vectors with opposing z values
  vector.z = -1.0
  var end = new Vector3(vector.x, vector.y, 1.0)
  vector.unproject(camera)
  end.unproject(camera)
  // find direction from vector to end
  end.sub(vector).normalize()
  return new Raycaster(vector, end)
}
export function screenToWorld(x, y, camera) {
  var mv = new Vector3(x, y, 0.5)
  var raycaster = pickingRay(mv, camera)
  var planeZ = new Plane(new Vector3(0, 0, 1), 0)
  const intersection = raycaster.ray.intersectPlane(planeZ, new Vector3())

  // Three.js v0.180.0: intersectPlane returns null when ray doesn't intersect
  if (intersection === null) {
    console.warn('camera-utils screenToWorld: Ray does not intersect Z plane, returning null')
    return null
  }

  return intersection
}
export function mouseToWorld(mouseEvent, camera) {
  var x = (mouseEvent.clientX / window.innerWidth) * 2 - 1
  var y = (mouseEvent.clientY / window.innerHeight) * 2 - 1
  return screenToWorld(x, y, camera)
}
export function screenCenterToWorld(camera) {
  return screenToWorld(window.innerWidth / 2, window.innerHeight / 2, camera)
}
